import { render, staticRenderFns } from "./LoadingBar.vue?vue&type=template&id=2d658869&scoped=true"
import script from "./LoadingBar.vue?vue&type=script&lang=js"
export * from "./LoadingBar.vue?vue&type=script&lang=js"
import style0 from "./LoadingBar.vue?vue&type=style&index=0&id=2d658869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d658869",
  null
  
)

export default component.exports